/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountThemeSettings model module.
 * @module model/AccountThemeSettings
 * @version V1
 */
class AccountThemeSettings {
    /**
     * Constructs a new <code>AccountThemeSettings</code>.
     * @alias module:model/AccountThemeSettings
     */
    constructor() { 
        
        AccountThemeSettings.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountThemeSettings</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountThemeSettings} obj Optional instance to populate.
     * @return {module:model/AccountThemeSettings} The populated <code>AccountThemeSettings</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountThemeSettings();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('reviewScreenTheme')) {
                obj['reviewScreenTheme'] = ApiClient.convertToType(data['reviewScreenTheme'], 'Number');
            }
            if (data.hasOwnProperty('defaultAnnotationTools')) {
                obj['defaultAnnotationTools'] = ApiClient.convertToType(data['defaultAnnotationTools'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountThemeSettings</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountThemeSettings</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} id
 */
AccountThemeSettings.prototype['id'] = undefined;

/**
 * @member {Number} accountId
 */
AccountThemeSettings.prototype['accountId'] = undefined;

/**
 * @member {Number} reviewScreenTheme
 */
AccountThemeSettings.prototype['reviewScreenTheme'] = undefined;

/**
 * @member {String} defaultAnnotationTools
 */
AccountThemeSettings.prototype['defaultAnnotationTools'] = undefined;






export default AccountThemeSettings;

